export default "__VITE_ASSET__BsiV_tvG__"